var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.result),expression:"result"}],staticClass:"textarea textarea-code",attrs:{"rows":"16"},domProps:{"value":(_vm.result)},on:{"input":function($event){if($event.target.composing){ return; }_vm.result=$event.target.value}}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/common/content/string/string-text.vue?vue&type=template&id=5523f2c8
// module id = AE6F
// module chunks = 0